@if(!isLoading) {
  <div class="compliance" *transloco="let t; prefix: 'assetOverview.compliance'">
    <div class="compliance-header">
      <span class="compliance-header-title">
        {{ t('title') }}
      </span>
  
      <button class="compliance-header-upload-button" (click)="openUploadDocumentModal()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.33203 10.0013H8.66536V6.0013H10.6654L7.9987 2.66797L5.33203 6.0013H7.33203V10.0013Z" fill="#EE2737"/>
          <path d="M13.332 11.9987H2.66536V7.33203H1.33203V11.9987C1.33203 12.734 1.93003 13.332 2.66536 13.332H13.332C14.0674 13.332 14.6654 12.734 14.6654 11.9987V7.33203H13.332V11.9987Z" fill="#EE2737"/>
        </svg>
          
        <span class="compliance-header-upload-button-text">
          {{ t('uploadDocument') }}
        </span>
      </button>
    </div>
  
    <div class="main-table">
      <table class="table">
        <thead>
          <tr>
            <th>{{ t('documentType') }}</th>
          </tr>
        </thead>
        <tbody>
          @if(!complianceDocuments.length) {
            <span class="table__no-data">
              <app-empty-state></app-empty-state>
            </span>
          }
          @for(row of complianceDocuments; track row.documentId) {
            <tr>
              <td class="document-cell">
                <app-compliance-document-row [row]="row" (viewDocument)="onViewDocument($event)" (editDocument)="onEditDocument($event)" (deleteDocument)="onDeleteDocument($event)"></app-compliance-document-row>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
} @else {
  <div class="spinner-container d-flex align-items-center justify-content-center spinner-border"></div>
}